import React, { useEffect } from "react";
import { StartActivity, sleep } from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import { render } from "@testing-library/react";
import { components } from "react-select";

class KoppelenGebruiker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { userRegisteredRoles: [] };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    $("#cover-spin").show(0);

    var model = {
      gebruikers: [],
    };

    var el = $("input[name=gebruiker]:checked");
    for (let i = 0; i < el.length; i++) {
      model.gebruikers.push({
        identification: el[i].id,
        display: [{ path: "$.name", value: el[i].value }],
      });
    }

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    StartActivity(
      model,
      selectedIds,
      "eb2f63ee-2ed8-4692-8dd4-28f951cbecbe",
      CallBackFunctions.GebruikerSavedCallback,
      window.$catalog_management_units_token
    );
  }

  async handleChange(event) {
    // this.setState({ value: evenevent.target.valuet.target.value });

    window.$mm_management_units_maat_page_number = 1;

    let result = await omnimap.GetUsersAction(
      window.$mm_management_units_maat_page_number,
      12,
      event.target.value,
      window.$catalog_management_units_token
    );
    CallBackFunctions.GebruikerCallback(result, this.state.userRegisteredRoles);
  }

  componentDidMount() {
    var that = this;
    $("#koppelen_gebruiker_aan_gebied").on(
      "show.bs.modal",
      async function (event) {
        window.$mm_management_units_maat_page_number = 1;

        let userRegisteredRoles = await omnimap.GetRelationAction(
          window.$catalog_area_selectedIds[0],
          1,
          30,
          window.$catalog_management_units_token
        );

        await that.setState({ userRegisteredRoles: userRegisteredRoles.data });

        let result = await omnimap.GetUsersAction(
          window.$catalog_area_gebruiker_page_number,
          12,
          "",
          window.$catalog_management_units_token
        );
        CallBackFunctions.GebruikerCallback(result, userRegisteredRoles.data);
      }
    );

    /***MODAL SCROLL END OF BOTTOM***/
    $("#koppelen-gebruiker-grp").scroll(async function () {
      var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0

      var test1 = $("#koppelen-gebruiker-grp").prop("scrollHeight");
      var test2 = $("#koppelen-gebruiker-grp").scrollTop();
      var test3 = $("#koppelen-gebruiker-grp").height();

      var result = test1 - test2;
      var result2 = test3 + buffer;
      if (
        $("#koppelen-gebruiker-grp").prop("scrollHeight") -
          $("#koppelen-gebruiker-grp").scrollTop() <=
        $("#koppelen-gebruiker-grp").height() + buffer
      ) {
        window.$mm_management_units_maat_page_number++;

        let result = await omnimap.GetUsersAction(
          window.$mm_management_units_maat_page_number,
          12,
          "",
          window.$catalog_management_units_token
        );
        CallBackFunctions.GebruikerCallback(
          result,
          that.state.userRegisteredRoles
        );
      }
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="koppelen_gebruiker_aan_gebied"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Koppelen gebruiker aan gebied</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <input
                type="search"
                className="modal-search"
                placeholder=""
                value={this.state.value}
                onChange={this.handleChange}
              />
              <div className="modal-scroll">
                <div id="koppelen-gebruiker-grp" className="radio-grp max-height-290" />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="area_gebruiker_save"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default KoppelenGebruiker;
